<div *ngIf="!time" >
  <div class="form-floating d-flex datepicker_contain" id="datepicker_contain" (keydown.tab)="onTabs($event)" >
    <input
      class="form-control"
      id="floatingInput"
      autocomplete="off"
      [(ngModel)]="inputValue"
      (ngModelChange)="inputValueEmit.emit(inputValue)"
      placeholder="name@example.com"
      ngbDatepicker
      #d="ngbDatepicker"
      readonly="true"
      [disabled]="isDisabled"
      [required]="inputReqValidation"
      [dayTemplate]="dayTemplate"
      [minDate]="minDate"
      (keydown.enter)="d.open()"
      (keydown.tab)="onTab($event,d)"
      (focus)="preventFocus($event)"
      [ngClass]="{
        'bottom-left-fix': adjustPopupPosition === 'bottom-left', 
        'bottom-right-fix': adjustPopupPosition === 'bottom-right',
        'top-right-fix': adjustPopupPosition === 'top-right',
        'custom-vendor-input' : isVendorForm,
        'bottom-popup-fix': isVendorForm
      }"
    />

    <ng-template #dayTemplate let-date let-focused="focused">
      <span
        class="custom-day"
        [class.focused]="focused"
        [class.range]="isRange(date)"
        [class.start-date]="isStartDate(date)"
        [class.end-date]="isEndDate(date)"
        [class.faded]="isHovered(date) || isInside(date)"
        (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>

    <label for="floatingInput" class="label-transition d-flex align-items-center"
      [ngClass]="{'select_value': inputValue }"
      >{{ inputLabel
      }}<i *ngIf="inputReqValidation" class="fst-normal ps-1 p-0 text-danger"
        >*</i
      ></label
    >
    <span
      [ngClass]="{ invisible: !inputValue || isDisabled }"
      (click)="clearInput(); inputValueEmit.emit(inputValue)"
      class="position-absolute top-0 start-0 hand icon"
    >
      <app-svg-icon
        class="svgIcon"
        [src]="'../../../../assets/SVGIcons/undoSVG.svg'"
      ></app-svg-icon>
      <!-- <app-svg
        iconType="UndoSVG"
        class="svgIcon">
      </app-svg> -->

    </span>
    <img (click)="d.toggle()" [ngClass]="{'pe-none':isDisabled,'vendor-date-icon':isVendorForm}" class="hand date-icon" src="../../../../assets/SVGIcons/dateIcon.svg" alt="">
  </div>
</div>

<div *ngIf="time" >
  <div class="form-floating d-flex">
    <input
      class="form-control"
      id="floatingInput"
      autocomplete="off"
      style="padding-right: 1em;"
      type="time"
      [ngClass]="{noBg:!selectedTime}"
      [(ngModel)]="selectedTime"
      (ngModelChange)="inputValueEmit.emit(inputValue)"
      placeholder=""
      (focus)="onTimeFocus()" (blur)="onTimeBlur()"
    />

    <label for="floatingInput" class="label-transition d-flex align-items-center"
      >{{ inputLabel
      }}<i *ngIf="inputReqValidation" class="fst-normal ps-1 p-0 text-danger"
        >*</i
      ></label
    >
    <span
      [ngClass]="{ invisible: !inputValue }"
      (click)="clearInput(); inputValueEmit.emit(inputValue)"
      class="position-absolute top-0 start-0 hand"
    >
      <!-- <app-svg-icon
        class="svgIcon"
        [src]="'../../../../assets/SVGIcons/undoSVG.svg'">
      </app-svg-icon> -->
      <app-svg
        iconType="UndoSVG"
        class="svgIcon pb-4">
      </app-svg>
    </span>
  </div>
</div>
